<template>
  <div>
    <toolbar></toolbar>
    <router-view></router-view>
  </div>
</template>
<script>
import Toolbar from "./Forecast/Toolbar.vue";
export default {
  components: { Toolbar },
  data: () => ({}),
  created() {
   // this.$router.push({ name: "dashboard" });
  },
};
</script>
<style >
</style>